import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import '../Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: '', detail: '' });
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError({ message: '', detail: '' });

    const result = await login(username, password);
    setLoading(false);

    if (result.success) {
      toast.success('Inicio de sesión exitoso');
      navigate('/dashboard');
      return;
    }

    const msg = result.message || 'Usuario o contraseña incorrectos.';
    const detail = result.detail || (result.status != null ? `Código HTTP: ${result.status}` : '');
    setError({ message: msg, detail });
    toast.error(msg);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Sistema de Abonos</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Usuario</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error.message && (
            <div className="login-error" role="alert">
              <div className="login-error-message">{error.message}</div>
              {error.detail && (
                <div className="login-error-detail" title="Detalle técnico para depuración">
                  {error.detail}
                </div>
              )}
            </div>
          )}
          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>
        <div className="login-info">
          <p>Usuario por defecto: <strong>admin</strong></p>
          <p>Contraseña: <strong>admin123</strong></p>
        </div>
      </div>
    </div>
  );
};

export default Login;

